import { Component, computed, input, ChangeDetectionStrategy } from '@angular/core';
import { HeroVariant } from '../../types/hero.types';

@Component({
  selector: 'dsrks-hero',
  templateUrl: './hero.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './hero.component.scss',
})
export class HeroComponent {
  public variant = input.required<HeroVariant>();
  public logoUrl = input.required<string>();
  public logoAltText = input.required<string>();
  public logoHeight = input<string>();
  public logoWidth = input<string>();

  protected cssClasses = computed(() => [`hero--${this.variant()}`]);
}
